import * as React from 'react';
import { NotebookContext } from '../../../context/NotebookContext';
import client from '../../../lib/client';
import { groupCreateOrUpdateMutation } from '../../../queries/groups';
import {
  GroupCreateOrUpdateMutation,
  GroupCreateOrUpdateMutationVariables
} from '../../../queries/__generated__/GroupCreateOrUpdateMutation';
import ErrorMessages from '../../ErrorMessages';
import { Input } from '../../forms';
import { Button, Card } from '../../ui';
import { ErrorMessagesArray } from '../tracker/types';
import { Group } from './types';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface GroupNameProps {
  group: Group;
  isUserGroupOwner: boolean;
}

const GroupName: React.FC<GroupNameProps> = ({ group, isUserGroupOwner }) => {
  const { notebook, reloadNotebook } = React.useContext(NotebookContext);
  const [name, setName] = React.useState(group.name);
  const [errors, setErrors] = React.useState<ErrorMessagesArray>([]);

  async function saveGroup() {
    const res = await client.mutate<
      GroupCreateOrUpdateMutation,
      GroupCreateOrUpdateMutationVariables
    >({
      mutation: groupCreateOrUpdateMutation,
      variables: {
        input: {
          notebookId: notebook.id,
          id: group.id,
          name
        }
      }
    });

    if (res.data!.createOrUpdateGroup.errors) {
      setErrors(res.data!.createOrUpdateGroup.errors);
      return;
    }
    if (errors.length) {
      setErrors([]);
    }

    reloadNotebook();
    toast('Settings saved!', { type: 'success' });
  }

  return (
    <Card className="mb2 pa4">
      <ErrorMessages errors={errors} />

      <Input
        label="name"
        className="mb3"
        value={name}
        onChange={e => setName(e.target.value)}
        placeholder="Enter a group name..."
        disabled={!isUserGroupOwner}
        data-testid="group-name-input"
      />

      {isUserGroupOwner && (
        <Button onClick={saveGroup} data-testid="save-info-button">
          Save
        </Button>
      )}
    </Card>
  );
};

export default GroupName;
